import SuitCaseIconFilled from 'components/icons/SuitCaseFilled';
import { StyledIconWrapper } from 'components/new-ui/base/page-header/styles';

const ThirdPartyJobIcon = () => {
    return (
        <StyledIconWrapper style={{ width: 24, height: 24, borderRadius: 6 }}>
            <SuitCaseIconFilled style={{ fontSize: 14 }} />
        </StyledIconWrapper>
    );
};

export default ThirdPartyJobIcon;
